"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _ref = _react["default"].createElement(_MenuItem["default"], {
  disabled: true,
  component: "div",
  height: 35
}, _react["default"].createElement(_Typography["default"], {
  noWrap: true,
  variant: "body1"
}, "Loading"));

var LoadingMessage = function LoadingMessage() {
  return _ref;
};

var _default = LoadingMessage;
exports["default"] = _default;